export const API_BASE_URL = process.env.REACT_APP_API_URL || '';

/**
 * Wrapper around fetch() that automatically:
 * 1. Attaches the API_BASE_URL
 * 2. Injects JWT Authorization header
 * 3. Handles JSON parsing
 */
export const authFetch = async (endpoint, options = {}) => {
    const token = localStorage.getItem('token'); // Retrieve your JWT

    const defaultHeaders = {
        'Content-Type': 'application/json',
        ...(token && { 'Authorization': `Bearer ${token}` }), // Attach token if it exists
    };

    const config = {
        ...options,
        headers: {
            ...defaultHeaders,
            ...options.headers,
        },
    };

    // Construct the full URL (handling leading slashes)
    const url = endpoint.startsWith('http') 
        ? endpoint 
        : `${API_BASE_URL}${endpoint.startsWith('/') ? '' : '/'}${endpoint}`;

    try {
        const response = await fetch(url, config);

        if (response.status === 401) {
            // Optional: Redirect to login if token is expired/invalid
            // window.location.href = '/login';
        }

        return response;
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
};